export * from '@arch-log/webapp.modules/address/model/fields'
export const Id = 'id'
export const Name = 'name'
export const PropertyType = 'property_type'
export const ConstructionType = 'construction_type'
export const ConstructionArea = 'area'
export const CreatedAt = 'created_at'
export const UpdatedAt = 'updated_at'

export const GroundFloors = 'ground_floors'
export const BasementFloors = 'basement_floors'
export const ConstructionStartDate = 'start_date'
export const ConstructionEndDate = 'completion_date'
